import { ProfileTransferTypes, TransferActions } from './types';
import { ProfileTransfer } from '../../models/profile';

const initialState: ProfileTransfer = {
  loading: false,
  transferStatus: false,
  error: undefined,
  isExistAccount: false,
};

const profileTransferReducer = (state = initialState, action: TransferActions) => {
  switch (action.type) {
    case ProfileTransferTypes.TRANSFER_PROFILE_SUBMIT:
      return {
        ...state,
        loading: true,
      };
    case ProfileTransferTypes.TRANSFER_PROFILE_SUBMIT_SUCCESS:
      return {
        ...state,
        transferStatus: true,
        error: undefined,
      };
    case ProfileTransferTypes.TRANSFER_PROFILE_SUBMIT_FAILURE:
      return {
        ...state,
        loading: false,
        transferStatus: false,
        error: action.error,
      };
    case ProfileTransferTypes.TRANSFER_ACCOUNT_EXIST_SUBMIT_SUCCESS:
      return {
        ...state,
        loading: false,
        isExistAccount: true,
      };
    case ProfileTransferTypes.TRANSFER_ACCOUNT_EXIST_SUBMIT_FAILURE:
      return {
        ...state,
        loading: false,
        isExistAccount: false,
      };
  }
  return state;
};

export default profileTransferReducer;